export enum Mode {
  edit,
  chat,
  addParent
};
